<!--Получает дерево, строит v-treeview по полученному дереву, с добавлением иконки и надписи,
по нажатию на элементы вызывает автобусом таблицу-->
<template>
  <v-treeview
    :items="tree" :open="open" style="max-height: 270px" class="overflow-y-auto"
    item-children="children"
    item-key="name"
    open-on-click
    hoverable>
      <template v-slot:prepend="{item, open, leaf}">
        <v-icon v-if="!leaf">
          {{ open ? "mdi-folder-open" : "mdi-folder" }}
        </v-icon>
        <template v-else>
          <v-icon @click="getTable(item)">
            mdi-file-excel
          </v-icon>
          <span class="caption" @click="getTable(item)">
            Таблица
          </span>
        </template>
      </template>
      <template v-slot:label="{ item, leaf }">
        <v-tooltip v-if="leaf" bottom>
          <template v-slot:activator="{on, attrs }">
            <span slot="activator" @click="getTable(item)" v-bind="attrs " v-on="on"> {{ item.name }}</span>
          </template>
          <span> {{ item.name }}</span>
        </v-tooltip>
        <v-tooltip v-else bottom>
          <template v-slot:activator="{on, attrs }">
            <span slot="activator" v-bind="attrs " v-on="on"> {{ item.name }}</span>
          </template>
          <span> {{ item.name }}</span>
        </v-tooltip>
      </template>
    </v-treeview>
</template>

<script>

import {bus} from "@/main";
import axios from "axios";

export default {
  name: "selected-region-tree",
  props: {
    regionId: Number,
    activeYear: Number,
    tree: []
  },
  data() {
    return {
      open: [],
    };
  },
  methods: {
    getTable(item) {
      axios
        .post("/eco-passport/check-permission", {tablePermission: item.permissionCode})
        .then(() => {
          let info = {
            headerID: item.idHeader,
            regionId: this.regionId,
            tableName: item.name,
            selectedYear: this.activeYear
          };
          bus.$emit('selectedTable', info)
        })
        .catch(() => {
          let errorMessage = {
            message: "Для доступа к этой таблице, вы должны быть авторизованными на сайте,\n а также запросить соответствующие права в министерстве экологии Красноярского края \n",
            show: true,
            color: "orange",
            centered: true,
            textColor: "#000",
            timeout: 6000
          }
          bus.$emit('message', errorMessage)
        })
    },
  }
}
</script>

<style>
</style>